import React, { useState } from "react";
import { useSelector } from "react-redux";
import usePageTitle from '../../hooks/usePageTitle';
import Profile from "../../components/Dashboard/Setting/Profile";
import Studio from "../../components/Dashboard/Setting/Studio";
import Security from "../../components/Dashboard/Setting/Security";
import DashboardShell from "../../components/Dashboard/DashboardShell";
import { useTranslation } from "react-i18next";

export default function SettingPage() {
  usePageTitle('Settings');
  const user = useSelector((state) => state.user);
  const [openTab, setOpenTab] = useState(1);
  const { t } = useTranslation();
  const tabs = [
    { title: t("Profile"), count: 1 },
    { title: user.role === "Actor" ? t("Agent") : t("Studio"), count: 2 },
    { title: t("Security"), count: 3 },
  ];

  return (
    <DashboardShell role={user.role} pageTitle={t("Settings")}>
      <div className="tw-rounded-xl tw-bg-[#280D41] tw-border tw-border-white/10 tw-overflow-hidden">
        <div className="tw-flex tw-border-b tw-border-white/10">
          {tabs.map((tab, i) => (
            <button
              key={tab.title}
              type="button"
              onClick={() => setOpenTab(tab.count)}
              className={`tw-flex-1 tw-py-3 tw-text-sm tw-font-medium tw-transition-colors tw-border-0 tw-cursor-pointer
                ${i > 0 ? "tw-border-l tw-border-white/10" : ""}
                ${openTab === tab.count
                  ? "tw-bg-[#712CB0] tw-text-white"
                  : "tw-bg-transparent tw-text-white/50 hover:tw-bg-white/5 hover:tw-text-white"
                }`}
            >
              {tab.title}
            </button>
          ))}
        </div>
        <div className="tw-p-6">
          {openTab === 1 && <Profile />}
          {openTab === 2 && <Studio isActor={user.role === "Actor"} />}
          {openTab === 3 && <Security />}
        </div>
      </div>
    </DashboardShell>
  );
}
